module.exports = __webpack_public_path__ + "img/4.1e3c780f.jpg";